var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"excelSlot",on:{"click":function($event){return _vm.$emit('downloadExcel',true)}}},[_c('img',{staticClass:"excelIcon",attrs:{"src":require("@/assets/images/excel-icon.svg"),"alt":"excel"}})])}
var staticRenderFns = []

export { render, staticRenderFns }